export function CalculatePercentage(vendorConfirmQty, totalWarehouseQuantity) {
  if (vendorConfirmQty >= totalWarehouseQuantity) {
    return 0;
  }
  const overReceiptQuantity = totalWarehouseQuantity - Number(vendorConfirmQty);
  const percentage = (overReceiptQuantity / vendorConfirmQty) * 100;

  return Number(percentage.toFixed(2));
}
